// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c4bbc3c8","453":"0da267f8","667":"a7cacc88"}[chunkId] + ".chunk.js";
};